export const EXPIRED_TOKEN_ERROR_MESSAGE =
  'We’re sorry, this link has expired.';
export const INVALID_TOKEN_ERROR_MESSAGE = 'Something went wrong';
export const UNKNOWN_ERROR_MESSAGE = 'Uh oh! Looks like something went wrong.';

export const EXPIRED_TOKEN_ERROR_SUB_MESSAGE =
  'Please check with the person who shared it with you to see if there’s a new link available';
export const INVALID_TOKEN_ERROR_SUB_MESSAGE =
  'This link is either invalid or you do not have permission to access this link.';
export const UNKNOWN_ERROR_SUB_MESSAGE =
  'Try to refresh the page or request a new link from your Zillow representative.';
